export const IconChevronDown = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            style={{ pointerEvents: 'none' }}>
            <defs />
            <path
                id='Vector'
                d='M4.76 8.32C5.13 7.91 5.77 7.89 6.17 8.26L12 13.63L17.82 8.26C18.22 7.89 18.86 7.91 19.23 8.32C19.6 8.72 19.58 9.36 19.17 9.73L12.67 15.73C12.29 16.08 11.7 16.08 11.32 15.73L4.82 9.73C4.41 9.36 4.39 8.72 4.76 8.32Z'
                fill='currentcolor'
                fillOpacity='1'
                fillRule='evenodd'
            />
        </svg>
    );
};
